import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Row,
    Col,
    Card,
    Button,
    Empty,
    List as AntList,
    Tag,
    Icon,
    Modal,
    Select
} from "antd";

import AddCaseForm from "forms/add-case-form";
import {
    addCaseEntry,
    removeCaseEntry,
    openCase
} from "store/actions/case-create-actions";
import CaseService from "services/case-service";
import BulkCaseCreate from "forms/bulk-case-create-form";
import { CaseEntryRecord } from "records/case-entry-record";
import { STATE_STATUS } from "constants/index";
const ListItem = AntList.Item;
const Option = Select.Option;

const options = [
    {
        label: "Anchor Bulk Upload",
        value: 1
    },
    {
        label: "Distributor Bulk Upload",
        value: 2
    }
];

class CaseCreateView extends React.Component {
    formRefs = {};
    state = {
        openUploadModal: false,
        selectedBulkOption: 1
    };
    getFormRefs(caseID) {
        if (this.formRefs[caseID]) {
            return this.formRefs[caseID];
        }
        this.formRefs[caseID] = React.createRef();
        return this.formRefs[caseID];
    }

    addCaseEntry = () => {
        this.props.addCaseEntry();
    };
    submitForm = () => {
        let casesToOpen = new Map({});
        new Map(this.formRefs).map((_, caseID) => {
            if (
                this.props.cases.get(caseID).status !==
                STATE_STATUS.INSTANTIATED
            ) {
                return;
            }
            _.current.validateFields((error, values) => {
                if (!error) {
                    casesToOpen = casesToOpen.set(
                        caseID,
                        new CaseEntryRecord({
                            ...values
                        }).set("status", STATE_STATUS.CREATING)
                    );
                }
            });
        });
        if (casesToOpen.size > 0) {
            this.props.openCase(casesToOpen);
        }
    };
    getTagColor = status => {
        /*eslint-disable*/
        switch (status) {
            case STATE_STATUS.CREATING:
                return "#e8e8e8";
            case STATE_STATUS.CREATED:
                return "#008dff";
            case STATE_STATUS.CREATE_FAILED:
                return "#87d068";
        }
        /*eslint-enable*/
    };

    closeModal = () => {
        this.setState({
            openUploadModal: false
        });
    }

    getListActions(caseEntry) {
        if (caseEntry.status === STATE_STATUS.CREATED) {
            return [
                <a
                    key={"case-view"}
                    onClick={() =>
                        this.props.history.replace(
                            `/app/inbox/${caseEntry.case_create_id}/case_details`,
                            {
                                action: "view",
                                caseId: caseEntry.case_create_id,
                                companyId: caseEntry.case_create_company_id,
                                name: caseEntry.company_name,
                                tabId: "case_details"
                            }
                        )
                    }
                >
                    View
                </a>
            ];
        }
        if (caseEntry.status === STATE_STATUS.CREATE_FAILED) {
            return ["retry", "edit"];
        }
        return [];
    }

    uploadBulk = (values) => {
        let data = new FormData();
        if (values.anchor) {
            data.append("anchor_id", values.anchor.id);
        } else if (values.seller) {
            data.append("seller_id", values.seller.id);
        }
        data.append("file", values.file);
        CaseService.bulkCaseCreate(data).then(({ error }) => {
            if (!error) {
                this.closeModal();
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <Row className={"p-5 h-100"}>
                    <Col span={24} className={"mb-10"}>
                        <Button icon={"arrow-left"} onClick={() => this.props.history.replace("/app/inbox")}>{"Back"}</Button>
                    </Col>
                    <Col span={24} className={"mb-10"}>
                        <Card
                            className={"padless-card"}
                            title={"New Case"}
                            extra={[
                                <a
                                    key={"bulk-upload"}
                                    onClick={() => this.setState({
                                        openUploadModal: true
                                    })}
                                    className={"mr-10"}
                                >
                                    {"Bulk Upload"}
                                </a>,
                                <a
                                    key={"add"}
                                    onClick={this.addCaseEntry}
                                    className={"mr-10"}
                                >
                                    <Icon type={"plus"} /> Add Another
                                </a>,
                                <Button
                                    key={"create"}
                                    type={"primary"}
                                    onClick={this.submitForm}
                                >
                                    <Icon type={"check"} /> Create
                                </Button>
                            ]}
                        >
                            <div className={"p-10"}>
                                {this.props.cases.filter(
                                    _ => _.status === STATE_STATUS.INSTANTIATED
                                ).size === 0 ? (
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    ) : null}
                                {this.props.cases
                                    .filter(
                                        _ => _.status === STATE_STATUS.INSTANTIATED
                                    )
                                    .map((caseRecord, caseID) => (
                                        <AddCaseForm
                                            key={caseID}
                                            // disabledFields={["type", "proposed_limit", "priority", "lead_type", "bank", "product"]}
                                            ref={this.getFormRefs(caseID)}
                                            values={caseRecord}
                                            onSubmit={this.submitForm.bind(
                                                null,
                                                caseID
                                            )}
                                        />
                                    ))
                                    .toList()
                                    .toArray()}
                            </div>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title={"Case Status"}>
                            <AntList itemLayout={"horizontal"}>
                                {this.props.cases
                                    .filter(
                                        _ => _.status !== STATE_STATUS.INSTANTIATED
                                    )
                                    .map((caseEntry, caseID) => (
                                        <ListItem
                                            key={caseID}
                                            actions={this.getListActions(caseEntry)}
                                        >
                                            <ListItem.Meta
                                                title={caseEntry.company_name}
                                            />
                                            <div>
                                                <Tag
                                                    color={this.getTagColor(
                                                        caseEntry.status
                                                    )}
                                                >
                                                    {caseEntry.status}
                                                </Tag>
                                            </div>
                                        </ListItem>
                                    ))
                                    .toList()
                                    .toJS()}
                            </AntList>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    visible={this.state.openUploadModal}
                    destroyOnClose={true}
                    closable={true}
                    onCancel={() => this.setState({
                        openUploadModal: false
                    })}
                    footer={null}
                >
                    <div className={"justify-content-space-around"}>
                        <div className={"d-flex mb-10"}>
                            <div className={"fb-50"}>
                                <Select
                                    value={this.state.selectedBulkOption}
                                    onSelect={(val) => this.setState({
                                        selectedBulkOption: val
                                    })}
                                >
                                    {options.map(_ => (
                                        // eslint-disable-next-line react/jsx-key
                                        <Option value={_.value}>
                                            {_.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className={"fb-50"}>
                                <Button 
                                    type={"link"} 
                                    href= {
                                        this.state.selectedBulkOption === 1 ? 
                                            `https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Anchor-On-Boarding.xlsx`
                                            : `https://assets-public-progfin.s3.ap-south-1.amazonaws.com/los/Distributor-On-Boarding.xlsx`
                                    }>
                                    {"Download Format"}
                                </Button>
                            </div>
                        </div>
                        <BulkCaseCreate
                            uploadBulk={this.uploadBulk}
                        />
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

CaseCreateView.propTypes = {
    cases: PropTypes.object,
    addCaseEntry: PropTypes.func,
    removeCaseEntry: PropTypes.func,
    openCase: PropTypes.func,
    history: PropTypes.object
};

const mapStateToProps = state => ({
    cases: state.caseCreate.get("cases")
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addCaseEntry,
            removeCaseEntry,
            openCase
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaseCreateView);
